var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, DropdownDivider, DropdownHeader, Grid, Icon, Input, Message, Select } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import AdminEditKitForm from "../kit/automated-pro/AdminEditKitForm";
import { cleanUpIshRnaSeq, debounce } from "../kit/automated-pro/EditKitForm";
import { miValidatedIcon } from "../kit/automated-pro/ProbeSetForm";
import { Accession, BindingSite, ProbeSetFamily } from "../kit/automated-pro/RnaCatalog";
import { rnaCishKitToAdminFormState } from "../kit/automated-pro/RnaCishKitToAdminFormState";
import ManualProAdminKitForm from "../kit/manual-pro/ManualProAdminKitForm";
import { manualProKitToAdminFormState } from "../kit/manual-pro/ManualProKitToAdminFormState";
import EditKitForm from "../kit/rna-fish/EditKitForm";
import { AutomatedProKit, AutomatedProKitPrice, ManualProKit, RnaFishKit, RnaFishKitPrice, SimpleCatalogVariantProbeSet, SimpleLibraryOrganismCustomTargetProbeSet } from "../kit/rna-fish/KitModel";
import { uniqueBy } from "../kit/rna-fish/ProbeSetForm";
import { extractNameBeforeParenthesis, rnaFishKitToFormState } from "../kit/rna-fish/RnaFishKitToFormState";
import { getWithAuthn } from "../RequestHelpers";
var VariantDesignerModal = /** @class */ (function (_super) {
    __extends(VariantDesignerModal, _super);
    function VariantDesignerModal(props) {
        var _this = _super.call(this, props) || this;
        _this.debounceSearchQueryChange = debounce(function (event, data) {
            _this.onSearchQueryChange(event, data);
        }, 500);
        _this.effectiveOrganisms = function () {
            var organisms = _this.props.catalog.probeSet.catalog.organisms.map(function (o) {
                return {
                    text: o.name + " " + (o.scientificName.length > 0 && o.scientificName !== o.name ? '(' + o.scientificName + ')' : ''),
                    content: o.name + " " + (o.scientificName.length > 0 && o.scientificName !== o.name ? '(' + o.scientificName + ')' : ''),
                    value: o.id
                };
            });
            if (_this.state.newOrganismName.length !== 0) {
                organisms = organisms === null || organisms === void 0 ? void 0 : organisms.concat([
                    {
                        text: _this.state.newOrganismName,
                        content: _this.state.newOrganismName,
                        value: -1
                    }
                ]);
            }
            if (organisms !== undefined) {
                return uniqueBy(organisms, function (o) { return o.value; });
            }
            else {
                return [];
            }
        };
        _this.onOrganismChange = function (_, data) {
            var organism = data.value;
            var selectedOrganism = _this.props.catalog.probeSet.catalog.organisms.find(function (o) { return o.id === organism; });
            _this.setState({
                libraryOrganism: selectedOrganism,
                newOrganismName: '',
                newScientificName: '',
                probeSetFamily: undefined,
                newTarget: '',
                variant: undefined,
                newVariantName: '',
                probeSetFamilies: []
            });
        };
        _this.onAddNewOrganism = function (_, data) {
            var str = data.value;
            _this.setState({
                libraryOrganism: undefined,
                newOrganismName: str
            });
        };
        _this.onAddNewTarget = function (_, data) {
            var nt = data.value;
            _this.setState({
                probeSetFamily: undefined,
                newTarget: nt,
                variant: undefined,
                newVariantName: ''
            });
        };
        _this.onTargetChange = function (_, data) {
            if (typeof data.value === "number") {
                _this.setState({
                    searchLoading: true
                }, function () {
                    getWithAuthn("/admin/rna/search/probeSetFamilyId/" + encodeURIComponent(data.value))
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (jsonFamily) {
                        if (jsonFamily !== undefined && jsonFamily.psf != null) {
                            var family = new ProbeSetFamily(jsonFamily.psf.id, jsonFamily.psf.geneSymbol, jsonFamily.psf.description, jsonFamily.psf.geneType, jsonFamily.psf.accessions, jsonFamily.psf.synonyms, function (psf) {
                                return jsonFamily.psf.variants.map(function (v) {
                                    return {
                                        id: v.id,
                                        organism: _this.state.libraryOrganism,
                                        probeSetFamily: psf,
                                        name: v.name,
                                        designNumber: v.designNumber,
                                        targetMrnaSeq: v.targetMrnaSeq,
                                        bindingSites: v.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                        accession: v.accession ? new Accession(v.accession.id, v.accession.transcriptAccession, v.accession.accessionType, v.accession.transcriptLength, v.accession.transcriptName) : undefined,
                                        probeSetSize: v.probeSetSize,
                                        validated: v.validated,
                                        dcvScore: v.dcvScore,
                                        designType: v.designType
                                    };
                                });
                            }, function (psf) {
                                return {
                                    id: jsonFamily.psf.defaultVariant.id,
                                    organism: _this.state.libraryOrganism,
                                    probeSetFamily: psf,
                                    name: jsonFamily.psf.defaultVariant.name,
                                    designNumber: jsonFamily.psf.defaultVariant.designNumber,
                                    targetMrnaSeq: jsonFamily.psf.defaultVariant.targetMrnaSeq,
                                    bindingSites: jsonFamily.psf.defaultVariant.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                    accession: jsonFamily.psf.defaultVariant.accession ? new Accession(jsonFamily.psf.defaultVariant.accession.id, jsonFamily.psf.defaultVariant.accession.transcriptAccession, jsonFamily.psf.defaultVariant.accession.accessionType, jsonFamily.psf.defaultVariant.accession.transcriptLength, jsonFamily.psf.defaultVariant.accession.transcriptName) : undefined,
                                    probeSetSize: jsonFamily.psf.defaultVariant.probeSetSize,
                                    validated: jsonFamily.psf.defaultVariant.validated,
                                    dcvScore: jsonFamily.psf.defaultVariant.dcvScore,
                                    designType: jsonFamily.psf.defaultVariant.designType
                                };
                            });
                            var acc = family.accessions.find(function (a) { return a.transcriptAccession === _this.state.newAccession; });
                            if (acc !== undefined) {
                                _this.setState({
                                    accessionId: acc.id,
                                    newAccession: ''
                                });
                            }
                            _this.setState({
                                searchLoading: false,
                                probeSetFamily: family,
                                newTarget: '',
                                variant: undefined,
                                newVariantName: ''
                            });
                        }
                        else {
                            _this.setState({
                                searchLoading: false,
                                probeSetFamily: undefined,
                                newTarget: '',
                                variant: undefined,
                                newVariantName: '',
                                probeSetFamilies: []
                            });
                        }
                    });
                });
            }
            else {
                _this.setState({
                    searchLoading: false,
                    probeSetFamily: undefined,
                    newTarget: '',
                    variant: undefined,
                    newVariantName: '',
                    probeSetFamilies: []
                });
            }
        };
        _this.onSearch = function (options, value) {
            if (value.trim().length === 0) {
                return [];
            }
            else {
                return uniqueBy(options, function (o) { return o.value; });
            }
        };
        _this.onSearchChange = function (event, data) {
            if (_this.state.libraryOrganism !== undefined && data.searchQuery.length !== 0) {
                _this.debounceSearchQueryChange(event, data);
            }
        };
        _this.onSearchQueryChange = function (_, data) {
            var path = "";
            if (_this.state.libraryOrganism === undefined || data.searchQuery.length === 0) {
                _this.setState({
                    probeSetFamily: undefined,
                    newTarget: data.searchQuery.length === 0 ? '' : _this.state.newTarget,
                    variant: undefined,
                    newVariantName: '',
                    probeSetFamilies: [],
                    searchQuery: ''
                });
                return;
            }
            path = "/admin/rna/search/id/" +
                (encodeURIComponent(_this.state.libraryOrganism.id) + "/targetGene/") +
                ("" + encodeURIComponent(data.searchQuery));
            _this.setState({
                searchLoading: true
            }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            searchLoading: false,
                            searchQuery: data.searchQuery,
                            probeSetFamily: undefined,
                            variant: undefined,
                            newVariantName: '',
                            probeSetFamilies: resp.probeSetFamilyResults
                        });
                    }
                    else {
                        _this.setState({
                            searchLoading: false,
                            searchQuery: data.searchQuery,
                            probeSetFamily: undefined,
                            variant: undefined,
                            newVariantName: ''
                        });
                    }
                });
            });
        };
        _this.effectiveTargets = function () {
            var exactMatchFamilies = _this.state.probeSetFamilies.filter(function (psf) {
                return _this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.state.searchQuery);
            });
            var synonymFamilies = _this.state.probeSetFamilies.filter(function (psf) {
                return _this.searchQueryIsSynonymForProbeSetFamily(psf, _this.state.searchQuery);
            });
            var otherProbeSetFamilies = _this.state.probeSetFamilies.filter(function (psf) {
                return !_this.searchQueryIsSynonymForProbeSetFamily(psf, _this.state.searchQuery) &&
                    !_this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.state.searchQuery);
            });
            var options = [];
            options = options.concat((exactMatchFamilies.length > 0 || synonymFamilies.length > 0) ? [
                React.createElement(DropdownHeader, { key: 'recommended-header', content: 'Recommended' }),
                React.createElement(DropdownDivider, { key: 'recommended-divider' })
            ] : []).concat(exactMatchFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(synonymFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((otherProbeSetFamilies.length !== 0 && _this.state.searchQuery !== '') ? [
                React.createElement(DropdownHeader, { key: 'other-header', content: "Other Results for " + _this.state.searchQuery }),
                React.createElement(DropdownDivider, { key: 'other-divider' })
            ]
                : []).concat(otherProbeSetFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((_this.state.newTarget.length !== 0) ? [
                {
                    text: _this.state.newTarget,
                    value: -1
                }
            ] : []);
            return options;
        };
        _this.searchQueryIsSynonymForProbeSetFamily = function (f, searchQuery) {
            return !!f.synonyms.find(function (s) { return s.toLowerCase() === searchQuery.toLowerCase(); });
        };
        _this.searchQueryIsExactMatchToProbeSetFamily = function (f, searchQuery) {
            return f.geneSymbol.toLowerCase() === searchQuery.toLowerCase();
        };
        _this.probeSetFamilyHasMIValidatedEntry = function (f) {
            var _a, _b;
            if (((_a = _this.state.probeSetFamily) === null || _a === void 0 ? void 0 : _a.id) === f.id) {
                return (_b = _this.state.probeSetFamily) === null || _b === void 0 ? void 0 : _b.variants.some(function (v) { return v.validated === 'MI_VALIDATED'; });
            }
            else {
                return false;
            }
        };
        _this.effectiveVariants = function () {
            var variants = _this.state.probeSetFamily ? _this.state.probeSetFamily.variants
                .map(function (v) {
                var _a;
                return {
                    text: v.name,
                    description: ((_a = v.designNumber) !== null && _a !== void 0 ? _a : 'pending') + ' | ' + v.probeSetSize.toString(),
                    value: v.id
                };
            }) : [];
            if (_this.state.newVariantName.length > 0) {
                variants = variants.concat([
                    {
                        text: _this.state.newVariantName,
                        description: '',
                        value: -1
                    }
                ]);
            }
            return variants;
        };
        _this.onAddNewVariant = function (_, data) {
            var nv = data.value;
            _this.setState({
                variant: undefined,
                newVariantName: nv
            });
        };
        _this.onVariantChange = function (_, data) {
            var _a;
            var variant = data.value;
            var selectedVariant = (_a = _this.state.probeSetFamily) === null || _a === void 0 ? void 0 : _a.variants.find(function (v) { return v.id === variant; });
            _this.setState({
                variant: selectedVariant,
                newVariantName: ''
            });
        };
        _this.onAccessionChange = function (_, data) {
            var acc = data.value;
            _this.setState({
                accessionId: acc,
                newAccession: ''
            });
        };
        _this.onAddNewAccession = function (_, data) {
            var str = data.value;
            _this.setState({
                accessionId: undefined,
                newAccession: str
            });
        };
        _this.effectiveAccessions = function () {
            var accessions = _this.state.probeSetFamily ? _this.state.probeSetFamily.accessions.map(function (a) {
                return {
                    text: a.transcriptAccession,
                    content: a.transcriptAccession,
                    value: a.id
                };
            }) : [];
            if (_this.state.newAccession.length !== 0) {
                accessions = accessions.concat([
                    {
                        text: _this.state.newAccession,
                        content: _this.state.newAccession,
                        value: -1
                    }
                ]);
            }
            if (accessions !== undefined) {
                return uniqueBy(accessions, function (a) { return a.text; });
            }
            else {
                return [];
            }
        };
        _this.onSequenceChange = function (event) {
            var str = event.currentTarget.value;
            _this.setState({
                newSequence: cleanUpIshRnaSeq(str)
            });
        };
        _this.onProbeSetSizeChange = function (event) {
            var str = event.currentTarget.value;
            _this.setState({
                newProbeSetSize: str
            });
        };
        _this.onNewScientificNameChange = function (event) {
            var str = event.currentTarget.value;
            _this.setState({
                newScientificName: str
            });
        };
        _this.getKitTarget = function () {
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                return _this.props.probeSet.probeSetFamily.geneSymbol;
            }
            else {
                return _this.props.probeSet.target.name;
            }
        };
        _this.getKitVariant = function () {
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                return _this.props.probeSet.variant.name;
            }
            else {
                return "";
            }
        };
        _this.getKitAccession = function () {
            var _a;
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                var ps_1 = _this.props.probeSet;
                return ps_1.probeSetFamily.accessions.find(function (a) { var _a; return ((_a = ps_1.variant.accession) === null || _a === void 0 ? void 0 : _a.id) === a.id; }) ? (_a = ps_1.probeSetFamily.accessions.find(function (a) { var _a; return ((_a = ps_1.variant.accession) === null || _a === void 0 ? void 0 : _a.id) === a.id; })) === null || _a === void 0 ? void 0 : _a.transcriptAccession : "";
            }
            else {
                return _this.props.probeSet.target.accession;
            }
        };
        _this.getKitSequence = function () {
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                var ps = _this.props.probeSet;
                return ps.variant.targetMrnaSeq;
            }
            else {
                return _this.props.probeSet.target.targetMrnaSeq;
            }
        };
        _this.getKitProbeSetSize = function () {
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                var ps = _this.props.probeSet;
                return ps.customerProbeSetSize;
            }
            else {
                return _this.props.probeSet.probeSetSize;
            }
        };
        _this.findPsf = function (org, psfName) {
            getWithAuthn("/admin/rna/search/id/" +
                (encodeURIComponent(org.id) + "/targetGene/") +
                ("" + encodeURIComponent(psfName)))
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                if (resp !== undefined) {
                    var matchingPsf = resp === null || resp === void 0 ? void 0 : resp.probeSetFamilyResults.find(function (p) { return p.geneSymbol.toLowerCase() === psfName.toLowerCase(); });
                    if (matchingPsf !== undefined) {
                        getWithAuthn("/admin/rna/search/probeSetFamilyId/" + encodeURIComponent(matchingPsf.id))
                            .then(function (psfResp) {
                            if (psfResp.status === 200) {
                                return psfResp.json();
                            }
                            else {
                                return undefined;
                            }
                        })
                            .then(function (jsonFamily) {
                            if (jsonFamily !== undefined && jsonFamily.psf != null) {
                                var psf = new ProbeSetFamily(jsonFamily.psf.id, jsonFamily.psf.geneSymbol, jsonFamily.psf.description, jsonFamily.psf.geneType, jsonFamily.psf.accessions, jsonFamily.psf.synonyms, function (psfCreator) {
                                    return jsonFamily.psf.variants.map(function (v) {
                                        return {
                                            id: v.id,
                                            organism: org,
                                            probeSetFamily: psfCreator,
                                            name: v.name,
                                            designNumber: v.designNumber,
                                            targetMrnaSeq: v.targetMrnaSeq,
                                            bindingSites: v.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                            accession: v.accession,
                                            probeSetSize: v.probeSetSize,
                                            validated: v.validated,
                                            dcvScore: v.dcvScore,
                                            designType: v.designType
                                        };
                                    });
                                }, function (defaultPsfCreator) {
                                    return {
                                        id: jsonFamily.psf.defaultVariant.id,
                                        organism: org,
                                        probeSetFamily: defaultPsfCreator,
                                        name: jsonFamily.psf.defaultVariant.name,
                                        designNumber: jsonFamily.psf.defaultVariant.designNumber,
                                        targetMrnaSeq: jsonFamily.psf.defaultVariant.targetMrnaSeq,
                                        bindingSites: jsonFamily.psf.defaultVariant.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                        accession: jsonFamily.psf.defaultVariant.accession ? new Accession(jsonFamily.psf.defaultVariant.accession.id, jsonFamily.psf.defaultVariant.accession.transcriptAccession, jsonFamily.psf.defaultVariant.accession.accessionType, jsonFamily.psf.defaultVariant.accession.transcriptLength, jsonFamily.psf.defaultVariant.accession.transcriptName) : undefined,
                                        probeSetSize: jsonFamily.psf.defaultVariant.probeSetSize,
                                        validated: jsonFamily.psf.defaultVariant.validated,
                                        dcvScore: jsonFamily.psf.defaultVariant.dcvScore,
                                        designType: jsonFamily.psf.defaultVariant.designType
                                    };
                                });
                                var acc = psf.accessions.find(function (a) { return a.transcriptAccession === _this.state.newAccession; });
                                if (acc !== undefined) {
                                    _this.setState({
                                        accessionId: acc.id,
                                        newAccession: ''
                                    });
                                }
                                _this.setState({
                                    probeSetFamily: psf,
                                    newTarget: '',
                                    probeSetFamilies: [
                                        {
                                            id: psf.id,
                                            geneSymbol: psf.geneSymbol,
                                            description: psf.description,
                                            synonyms: psf.synonyms
                                        }
                                    ]
                                });
                            }
                        });
                    }
                }
            });
        };
        _this.confirmButton = function () {
            if (_this.state.libraryOrganism !== undefined &&
                _this.state.probeSetFamily !== undefined &&
                _this.state.variant !== undefined) {
                return true;
            }
            else {
                return (_this.state.libraryOrganism !== undefined || (_this.state.newOrganismName.length > 0 && _this.state.newScientificName.length > 0)) &&
                    (_this.state.probeSetFamily !== undefined || _this.state.newTarget.length > 0) &&
                    (_this.state.variant !== undefined || _this.state.newVariantName.length > 0) &&
                    (_this.state.newAccession.length > 0 || _this.state.newSequence.length > 0 || _this.state.accessionId !== undefined) &&
                    _this.state.newProbeSetSize.length > 0;
            }
        };
        _this.getWarningMessage = function () {
            if (_this.state.libraryOrganism !== undefined &&
                _this.state.probeSetFamily !== undefined &&
                _this.state.variant !== undefined) {
                return "You are about to assign the kit to the already existing selected catalog probeDesignVariant/design.";
            }
            else if (_this.state.libraryOrganism !== undefined &&
                _this.state.probeSetFamily !== undefined &&
                _this.state.newVariantName.length > 0 &&
                (_this.state.newAccession.length > 0 || _this.state.newSequence.length > 0 || _this.state.accessionId !== undefined) &&
                _this.state.newProbeSetSize.length > 0) {
                return "You are about to create a new probeDesignVariant/design for the selected catalog probeDesignOrganism and catalog target, and assign the kit to this newly created probeDesignVariant/design.";
            }
            else if (_this.state.libraryOrganism !== undefined &&
                _this.state.newTarget.length > 0 &&
                _this.state.newVariantName.length > 0 &&
                (_this.state.newAccession.length > 0 || _this.state.newSequence.length > 0 || _this.state.accessionId !== undefined) &&
                _this.state.newProbeSetSize.length > 0) {
                return "You are about to create a new target and probeDesignVariant/design for the selected catalog probeDesignOrganism, and assign the kit to this newly created probeDesignVariant/design.";
            }
            else if (_this.state.newOrganismName.length > 0 &&
                _this.state.newScientificName.length > 0 &&
                _this.state.newTarget.length > 0 &&
                _this.state.newVariantName.length > 0 &&
                (_this.state.newAccession.length > 0 || _this.state.newSequence.length > 0 || _this.state.accessionId !== undefined) &&
                _this.state.newProbeSetSize.length > 0) {
                return "You are about to create a new probeDesignOrganism, target and probeDesignVariant/design in the catalog, and assign the kit to this newly created probeDesignVariant/design.";
            }
            else {
                return "All necessary fields are yet to be filled.";
            }
        };
        _this.submit = function () {
            var _a, _b, _c;
            var body;
            if (_this.props.kit instanceof AutomatedProKit && _this.props.kitPrice instanceof AutomatedProKitPrice) {
                body =
                    AdminEditKitForm.serializeAutomatedProKit(rnaCishKitToAdminFormState(_this.props.catalog, _this.props.kit, _this.props.kitPrice));
            }
            else if (_this.props.kit instanceof RnaFishKit && _this.props.kitPrice instanceof RnaFishKitPrice) {
                body =
                    EditKitForm.serializeRnaFishKit(rnaFishKitToFormState(_this.props.catalog, _this.props.kit, true, _this.props.kitPrice));
            }
            else {
                body =
                    ManualProAdminKitForm.serializeManualProAdminKit(manualProKitToAdminFormState(_this.props.catalog, _this.props.kit, _this.props.kitPrice));
            }
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/items/id/" + encodeURIComponent(_this.props.item.id) + "/variant-assignment", {
                kit: body,
                orgId: (_a = _this.state.libraryOrganism) === null || _a === void 0 ? void 0 : _a.id,
                newOrganismName: _this.state.newOrganismName,
                newScientificName: _this.state.newScientificName,
                psfId: (_b = _this.state.probeSetFamily) === null || _b === void 0 ? void 0 : _b.id,
                newTarget: _this.state.newTarget,
                vId: (_c = _this.state.variant) === null || _c === void 0 ? void 0 : _c.id,
                newVariantName: _this.state.newVariantName,
                hcrAmplifier: _this.state.hcrAmplifier.id,
                accessionId: _this.state.accessionId,
                newAccession: _this.state.newAccession,
                newSequence: _this.state.newSequence,
                newProbeSetSize: _this.state.newProbeSetSize,
                channel: _this.props.channel,
                kitsProbeSetSize: _this.getKitProbeSetSize()
            });
        };
        _this.unassign = function () {
            var productType;
            if (_this.props.kit instanceof AutomatedProKit) {
                productType = 'AUTOMATED_PRO';
            }
            else if (_this.props.kit instanceof ManualProKit) {
                productType = 'MANUAL_PRO';
            }
            else {
                productType = 'RNA_FISH';
            }
            _this.props.deleteRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/items/id/" + encodeURIComponent(_this.props.item.id) + "/variant-assignment" +
                ("?productType=" + productType + "&channel=" + _this.props.channel));
        };
        var libraryOrganism;
        var psf;
        var probeSetFamilies = [];
        var variant;
        var hcrAmplifier;
        var newAccession = '';
        var newSequence = '';
        var newProbeSetSize = '';
        var newTarget = '';
        if (props.probeSet instanceof SimpleCatalogVariantProbeSet) {
            var orgId_1 = props.probeSet.organism.id;
            var psfId_1 = props.probeSet.probeSetFamily.id;
            var variantId_1 = props.probeSet.variant.id;
            hcrAmplifier = props.probeSet.hcrAmplifier;
            libraryOrganism = props.catalog.probeSet.catalog.organisms.find(function (o) { return o.id === orgId_1; });
            if (libraryOrganism !== undefined) {
                psf = libraryOrganism.probeSetFamilies.find(function (f) { return f.id === psfId_1; });
                if (psf !== undefined) {
                    probeSetFamilies = [
                        {
                            id: psf.id,
                            geneSymbol: psf.geneSymbol,
                            description: psf.description,
                            synonyms: psf.synonyms
                        }
                    ];
                    variant = psf.variants.find(function (v) { return v.id === variantId_1; });
                }
            }
        }
        else if (props.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet) {
            var orgId_2 = props.probeSet.organism.id;
            hcrAmplifier = props.probeSet.hcrAmplifier;
            newAccession = props.probeSet.target.accession;
            newSequence = cleanUpIshRnaSeq(props.probeSet.target.targetMrnaSeq);
            newProbeSetSize = props.probeSet.probeSetSize.toString();
            libraryOrganism = props.catalog.probeSet.catalog.organisms.find(function (o) { return o.id === orgId_2; });
            newTarget = props.probeSet.target.name;
        }
        else {
            hcrAmplifier = props.probeSet.hcrAmplifier;
            newAccession = props.probeSet.target.accession;
            newSequence = cleanUpIshRnaSeq(props.probeSet.target.targetMrnaSeq);
            newProbeSetSize = props.probeSet.probeSetSize.toString();
            libraryOrganism = props.catalog.probeSet.catalog.organisms.find(function (o) { return o.name.trim().toLowerCase() === extractNameBeforeParenthesis(props.probeSet.organism.name).toLowerCase(); });
            newTarget = props.probeSet.target.name;
        }
        _this.state = {
            libraryOrganism: libraryOrganism,
            newOrganismName: libraryOrganism ? '' : props.probeSet.organism.name,
            newScientificName: '',
            probeSetFamily: psf,
            newTarget: psf ? '' : newTarget,
            variant: variant,
            newVariantName: '',
            hcrAmplifier: hcrAmplifier,
            newAccession: newAccession,
            newSequence: newSequence,
            newProbeSetSize: newProbeSetSize,
            probeSetFamilies: probeSetFamilies,
            description: '',
            geneType: '',
            modes: ['ADMIN'],
            searchLoading: false,
            searchQuery: ''
        };
        return _this;
    }
    VariantDesignerModal.prototype.componentDidMount = function () {
        if (this.state.libraryOrganism !== undefined && this.state.newTarget.length > 0) {
            this.findPsf(this.state.libraryOrganism, this.state.newTarget);
        }
    };
    VariantDesignerModal.prototype.render = function () {
        var _a;
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeDesignOrganism', labelContent: "Organism | Kit's Organism: " + this.props.probeSet.organism.name },
                        React.createElement(Select, { placeholder: 'Type-in or select a probeDesignOrganism.', options: this.effectiveOrganisms(), onChange: this.onOrganismChange, search: true, allowAdditions: true, additionLabel: 'New Organism: ', additionPosition: "bottom", icon: false, onAddItem: this.onAddNewOrganism, clearable: true, selectOnBlur: false, text: this.state.libraryOrganism ?
                                this.state.libraryOrganism.name + " " + (this.state.libraryOrganism.scientificName.length > 0 && this.state.libraryOrganism.scientificName !== this.state.libraryOrganism.name ? '(' + this.state.libraryOrganism.scientificName + ')' : '') : (this.state.newOrganismName.length > 0 ? this.state.newOrganismName : 'Type-in or select probeDesignOrganism.'), selectOnNavigation: false, value: this.state.libraryOrganism ? this.state.libraryOrganism.id : (this.state.newOrganismName.length > 0 ? -1 : "") }))),
                React.createElement(Grid.Column, { width: 8 }, this.state.newOrganismName.length > 0 &&
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/newScientificName', labelContent: 'New Scientific Name' },
                        React.createElement(Input, { type: 'text', name: 'newScientificName', onChange: this.onNewScientificNameChange, value: this.state.newScientificName })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/target', labelContent: "Target | Kit's Target: " + this.getKitTarget() },
                        React.createElement(Select, { additionLabel: "New Target: ", additionPosition: "bottom", allowAdditions: true, onAddItem: this.onAddNewTarget, icon: false, clearable: true, disabled: (this.state.libraryOrganism == null && this.state.newOrganismName.length === 0), className: 'gene-symbol', loading: this.state.searchLoading, type: 'text', name: 'target-new', onChange: this.onTargetChange, onSearchChange: this.onSearchChange, options: this.effectiveTargets(), placeholder: 'Enter target gene (e.g., tpm3)', search: this.onSearch, spellCheck: false, text: this.state.probeSetFamily ?
                                this.state.probeSetFamily.geneSymbol + " " + (this.state.probeSetFamily.description.length > 0 ? '(' + this.state.probeSetFamily.description + ')' : '') : (this.state.newTarget.length > 0 ? this.state.newTarget : 'Enter target gene (e.g., tpm3)'), value: this.state.probeSetFamily ? this.state.probeSetFamily.id : (this.state.newTarget.length > 0 ? -1 : "") })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeDesignVariant', labelContent: "Variant | Kit's Variant: " + this.getKitVariant() },
                        React.createElement(Select, { additionLabel: "New Variant: ", additionPosition: "bottom", allowAdditions: true, onAddItem: this.onAddNewVariant, icon: false, clearable: true, disabled: (this.state.probeSetFamily == null && this.state.newTarget.length === 0), type: 'text', options: this.effectiveVariants(), search: true, placeholder: 'Variant Name', onChange: this.onVariantChange, text: this.state.variant ? this.state.variant.name : (this.state.newVariantName.length > 0 ? this.state.newVariantName : 'Variant Name'), value: this.state.variant ? this.state.variant.id : (this.state.newVariantName.length > 0 ? -1 : "") })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: "Accession | Kit's Accession: " + this.getKitAccession() },
                        React.createElement(Select, { search: true, allowAdditions: true, additionLabel: 'New Accession: ', additionPosition: "bottom", icon: false, clearable: true, selectOnBlur: false, options: this.effectiveAccessions(), disabled: this.state.variant !== undefined, onChange: this.onAccessionChange, onAddItem: this.onAddNewAccession, selectOnNavigation: false, value: this.state.variant ? (_a = this.state.variant.accession) === null || _a === void 0 ? void 0 : _a.id : this.state.accessionId ? this.state.accessionId : -1 })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: "Sequence | Kit's Sequence: " + this.getKitSequence() },
                        React.createElement(Input, { type: 'text', name: 'sequence', disabled: this.state.variant !== undefined, onChange: this.onSequenceChange, value: this.state.variant ? this.state.variant.targetMrnaSeq : this.state.newSequence })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSizeLookup', labelContent: "Probe Size | Kit's Probe Size: " + this.getKitProbeSetSize() },
                        React.createElement(Input, { type: 'number', name: 'probe-set-size', disabled: this.state.variant !== undefined, onChange: this.onProbeSetSizeChange, value: this.state.variant ? this.state.variant.probeSetSize : this.state.newProbeSetSize })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Button, { disabled: !this.confirmButton(), icon: 'plus', label: 'Submit', labelPosition: 'left', onClick: this.submit, positive: true }),
                    this.props.probeSet instanceof SimpleCatalogVariantProbeSet &&
                        React.createElement(Button, { icon: 'unlink', label: 'Unassign Variant', labelPosition: 'left', negative: true, onClick: this.unassign }))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(Message, { color: "yellow", content: this.getWarningMessage() }))));
    };
    return VariantDesignerModal;
}(React.PureComponent));
export default VariantDesignerModal;
//# sourceMappingURL=VariantDesignerModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/VariantDesignerModal.js
// module id = 1267
// module chunks = 0